import * as React from 'react';

import { Grid } from '@mui/material';

import { VIDEO_TUTORIALS } from '../constants';
import { VideoTutorial, Carousel } from './index';
import { useIntersectionObserver } from './utils';

function TutorialSection() {
  const { isIntersecting, ref } = useIntersectionObserver();

  return (
    <Grid
      container={true}
      justifyContent={'center'}
      className={'home-page__tutorial-container background-white max-container'}
    >
      <Grid item={true} xs={10} md={5} lg={4} className="home-page__tutorial-header-box max-screen">
        <div className={`fade-in-section ${isIntersecting ? 'is-visible' : ''}`} ref={ref}>
          <h1 data-qa="home-page__tutorial-video-title">Video Tutorials</h1>
          <p>
            Check out the step-by-step video tutorials to learn how to integrate the Skillz SDK into
            your games.
          </p>
        </div>
      </Grid>

      <Carousel size={3}>
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoOne} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoTwo} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoThree} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoFour} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoFive} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoSix} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoSeven} />
        <VideoTutorial id={'home-page__card-developers'} videoInfo={VIDEO_TUTORIALS.videoEight} />
      </Carousel>
    </Grid>
  );
}

export { TutorialSection };
